import React from "react";
import { motion } from "framer-motion";
import { DRINKS } from "../data/menu";

export const Drinks = () => {
  return (
    <section id="drinks" className="relative py-20 sm:py-32 bg-[#FFFDFB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="font-script text-[#FF6392] text-3xl -rotate-2 inline-block">cold, hot, dreamy,</p>
          <h2 className="font-serif-display text-3xl sm:text-5xl lg:text-6xl text-[#2D2327] tracking-tight mt-2">
            Pair it with a <span className="italic text-[#FF6392]">sip.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#4A3F44]">
            Frappés, milkshakes, matcha and an iced coffee crunch you crack with your spoon.
          </p>
        </div>

        <div className="mt-12 sm:mt-14 grid grid-cols-1 min-[420px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
          {DRINKS.map((drink, i) => (
            <motion.div
              key={drink.name}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              data-testid={`drink-card-${drink.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group"
            >
              <div className="aspect-[3/4] w-full overflow-hidden arch-mask bg-[#FFF0F3]">
                <img
                  src={drink.image}
                  alt={drink.name}
                  loading="lazy"
                  className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="mt-4 flex items-baseline justify-between gap-2">
                <h3 className="font-serif-display text-lg sm:text-xl text-[#2D2327] leading-tight">{drink.name}</h3>
                <span className="text-sm font-semibold text-[#FF6392] whitespace-nowrap">{drink.price}</span>
              </div>
              <p className="mt-1.5 text-sm text-[#4A3F44]/80 leading-snug">{drink.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Drinks;
